(function() {
  'use strict';

  function filter() {
    return function(input) {
      return _.isString(input);
    };
  }

  angular.module('blocks.utils')
    .filter('kzIsString', filter);
})();
